import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from "react-redux";
import store from "./store";
import React from 'react';
import {AxiosInterceptor} from "./api";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <AxiosInterceptor>
            <App/>
        </AxiosInterceptor>
    </Provider>
);

